module.exports = __webpack_public_path__ + "img/theme9.18ff34bb.png";